/** Variante de presentación / ítems por defecto del menú de perfil. */
export type UiUserProfileMenuVariant = 'system' | 'portal';

/** Icono vectorial incluido en la molécula (si no se usa `iconSrc`). */
export type UiProfileMenuBuiltInIcon = 'user' | 'notes' | 'tasks';

export interface UiProfileMenuItem {
  id: string;
  title: string;
  subtitle: string;
  /** Imagen en `public` (prioridad sobre `icon`) */
  iconSrc?: string | null;
  /** Icono integrado cuando no hay `iconSrc` */
  icon?: UiProfileMenuBuiltInIcon | null;
}

/** Ítems por defecto — variante `system`. */
export const UI_PROFILE_MENU_DEFAULT_ITEMS: readonly UiProfileMenuItem[] = [
  {
    id: 'profile',
    title: 'Mi perfil',
    subtitle: 'Configuración de la cuenta',
    icon: 'user',
  },
  {
    id: 'notes',
    title: 'Mis notas',
    subtitle: 'Mis notas diarias',
    icon: 'notes',
  },
  {
    id: 'tasks',
    title: 'Mis tareas',
    subtitle: 'Tareas pendientes y diarias',
    icon: 'tasks',
  },
];

/** Ítems por defecto — variante `portal`. */
export const UI_PROFILE_MENU_PORTAL_ITEMS: readonly UiProfileMenuItem[] = [
  {
    id: 'account',
    title: 'Mi cuenta',
    subtitle: 'Configuración de la cuenta',
    icon: 'user',
  },
];
